// extracted by mini-css-extract-plugin
export default {"container":"Ended_container__lCAlc","container__content":"Ended_container__content__uTefp","featurePreview":"Ended_featurePreview__r2t8g"};